export const DeviceTypeEnum = Object.freeze({
  mobile: 'mobile',
  tablet: 'tablet',
  laptop: 'laptop',
  desktop: 'desktop',
})

const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
}

export const deviceMin = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
}

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
}

export const deviceMax = {
  mobileS: `(max-width: 374px)`,
  mobileM: `(max-width: 424px)`,
  mobileL: `(max-width: 767px)`,
  tablet: `(max-width: 1023px)`,
  laptop: `(max-width: 1439px)`,
  laptopL: `(max-width: 2559px)`,
}